export const APP_MOUNTED = "Settings.APP_MOUNTED";
export const SET_APP_MOUNTED = "Settings.SET_APP_MOUNTED";
